<template>
  <div>
    <vs-row vs-align="center"
            vs-type="flex"
            vs-justify="end"
            vs-w="12">
      <vs-button @click="showDetailsPopUp=true">Flohmarkt erstellen</vs-button>
    </vs-row>
    <vs-input icon-no-border placeholder="Suchen ..."
              v-model="search"
              icon-pack="feather"
              icon="icon-search"
              size="large"
              class="w-full mt-6"
    />
    <div class="mt-5">
      <vs-tabs alignment="left" v-model="activeTab">
        <vs-tab label="bevorstehend">
          <transition-group tag="div" class="vx-row" name="trs-fade-out-fast" mode="out-in">
            <div v-for="event in searchEvents"
                 :key="event.id"
                 class="vx-col w-full lg:w-1/3 mb-base"
                 v-if="searchEvents"
            >
              <EventCard :event="event"/>
            </div>
          </transition-group>
        </vs-tab>
        <vs-tab label="vergangene">
          <div class="vx-row">
            <div v-for="event in searchEvents"
                 :key="event.id"
                 class="vx-col w-full lg:w-1/3 mb-base"
                 v-if="searchEvents"
            >
              <EventCard :event="event"/>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <!--    Event pop up-->
    <vx-modal :isFullScreen=true classContent="popup-example" title="Flohmarkt erstellen" :active.sync="showDetailsPopUp" v-if="showDetailsPopUp" detach>
      <vs-row vs-type="flex" vs-align="center" vs-w="12">
        <vs-row vs-type="flex" vs-align="center" vs-w="12">
          <vs-input class="inputx mb-3" style="width: 100%;" placeholder="Titel" v-model="newEventObj.title"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <flat-pickr :config="configDateTimePicker" style="width: 30%;" v-model="newEventObj.startdate"
                      placeholder="Startdatum und Zeit"/>
          <span>bis</span>
          <flat-pickr :config="configDateTimePicker" style="width: 30%;" v-model="newEventObj.enddate"
                      placeholder="Enddatum und Zeit"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="newEventObj.price_car_text"/>
          <vs-input class="inputx mb-3" style="width: 40%;" placeholder="Preis pro platz" type="number"
                    v-model="newEventObj.priceperplace_car"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="newEventObj.price_car_trailer_text"/>
          <vs-input class="inputx mb-3 ml-3" style="width: 40%;" placeholder="Preis pro platz"
                    type="number"
                    v-model="newEventObj.priceperplace_car_trailer"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="newEventObj.price_bus_text"/>
          <vs-input class="inputx mb-3 ml-3" style="width: 40%;" placeholder="Preis pro platz"
                    type="number"
                    v-model="newEventObj.priceperplace_bus"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="newEventObj.price_bus_2_text"/>
          <vs-input class="inputx mb-3 ml-3" style="width: 40%;" placeholder="Preis pro platz"
                    type="number"
                    v-model="newEventObj.priceperplace_bus_2"/>
        </vs-row>

        <vs-row>
          <vs-input class="inputx mb-3" style="width: 100%;" placeholder="Verfügbare Plätze"
                    v-model="newEventObj.availableplaces" :disabled="newEventObj.hasnums"/>
        </vs-row>
        <vs-row>
          <quill-editor style="width: 100%;" v-model="newEventObj.description"
                        placeholder="Marktdetails"></quill-editor>
        </vs-row>
        <vs-row vs-type="flex" class="pt-24" vs-w="12" style="z-index: 9999">
          <label class="dropdown">
            <div class="dd-button">
              {{ title === null ? 'Standort' : title }}
            </div>
            <input type="checkbox" class="dd-input">
            <ul class="dd-menu">
              <li v-for="location in eventLocations" v-bind:key="location.id"
                  @click="onLocationPress(location.id,location.title)">{{ location.title }}
              </li>
            </ul>

          </label>
        </vs-row>
        <vs-row vs-type="flex" class="pt-5" vs-w="12">
          <vs-checkbox v-model="newEventObj.isactive">Aktiv</vs-checkbox>
        </vs-row>
        <vs-row vs-type="flex" class="pt-5" vs-w="12">
          <vs-checkbox v-model="newEventObj.hasnums">Plätze sind nummeriert (gilt nur für Pratteln)</vs-checkbox>
        </vs-row>
        <vs-row vs-type="flex" class="pt-5" vs-w="12" style="z-index: 9999"
                v-if="newEventObj.hasnums">
          <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
            <span>von</span>
            <vs-input style="width: 30%;" v-model="minNums" type="number" min="1" @change="generateNums"/>
            <span>bis</span>
            <vs-input style="width: 30%;" v-model="maxNums" type="number" min="1" @change="generateNums"/>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="start" vs-w="12">
            <p>Wird einen Nummer markiert, ist sie besetzt</p><br>
          </vs-row>
          <vs-checkbox class="mr-5 pt-2" style="width: 50px" v-for="n in newEventObj.nums" :key="n.nr" v-model="n.busy">
            {{ n.nr }}
          </vs-checkbox>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="end" class="pt-5" vs-w="12">
          <vs-button @click="showConfirmPopUp=true" color="primary" type="filled">erstellen</vs-button>
        </vs-row>
      </vs-row>
      <vx-modal class="confirm-modal" title="Sind Sie sicher?" :active.sync="showConfirmPopUp" v-if="showConfirmPopUp" detach>
        <p>Sind Sie sicher, dass Sie diesen Flohmarkt erstellen wollen?</p>
        <vs-row vs-type="flex" vs-justify="end" class="pt-12" vs-w="12">
          <vs-button @click="onCreatePress" :disabled="creatBtnDisabled" color="success" type="filled">Ja</vs-button>
        </vs-row>
      </vx-modal>
    </vx-modal>
    <!--    Event pop up-->
  </div>
</template>
<script>
import EventCard from "./components/EventCard";
import flatPickr from 'vue-flatpickr-component';
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {mapActions} from 'vuex'

export default {
  components: {
    EventCard,
    flatPickr,
    quillEditor,
  },
  data: () => ({
    // upcomingEvents: [],
    // goneEvents: [],
    activeTab: 0,
    creatBtnDisabled: false,
    eventLocations: [],
    // city title
    title: null,
    // inputs
    search: '',
    minNums: 1,
    maxNums: 300,
    newEventObj: {
      title: null,
      startdate: null,
      starttime: null,
      enddate: null,
      endtime: null,
      priceperplace_car: null,
      priceperplace_car_trailer: null,
      priceperplace_bus: null,
      priceperplace_bus_2: null,
      availableplaces: 0,
      price_car_text: '',
      price_car_trailer_text: '',
      price_bus_text: '',
      price_bus_2_text: '',
      description: `...`,
      eventlocation: null,
      isactive: true,
      hasnums: false,
      nums: JSON.parse('[{"nr":1,"busy":0},{"nr":2,"busy":0},{"nr":3,"busy":0},{"nr":4,"busy":0},{"nr":5,"busy":0},{"nr":6,"busy":0},{"nr":7,"busy":0},{"nr":8,"busy":0},{"nr":9,"busy":0},{"nr":10,"busy":0},{"nr":11,"busy":0},{"nr":12,"busy":0},{"nr":13,"busy":0},{"nr":14,"busy":0},{"nr":15,"busy":0},{"nr":16,"busy":0},{"nr":17,"busy":0},{"nr":18,"busy":0},{"nr":19,"busy":0},{"nr":20,"busy":0},{"nr":21,"busy":0},{"nr":22,"busy":0},{"nr":23,"busy":0},{"nr":24,"busy":0},{"nr":25,"busy":0},{"nr":26,"busy":0},{"nr":27,"busy":0},{"nr":28,"busy":0},{"nr":29,"busy":0},{"nr":30,"busy":0},{"nr":31,"busy":0},{"nr":32,"busy":0},{"nr":33,"busy":0},{"nr":34,"busy":0},{"nr":35,"busy":0},{"nr":36,"busy":0},{"nr":37,"busy":0},{"nr":38,"busy":0},{"nr":39,"busy":0},{"nr":40,"busy":0},{"nr":41,"busy":0},{"nr":42,"busy":0},{"nr":43,"busy":0},{"nr":44,"busy":0},{"nr":45,"busy":0},{"nr":46,"busy":0},{"nr":47,"busy":0},{"nr":48,"busy":0},{"nr":49,"busy":0},{"nr":50,"busy":0},{"nr":51,"busy":0},{"nr":52,"busy":0},{"nr":53,"busy":0},{"nr":54,"busy":0},{"nr":55,"busy":0},{"nr":56,"busy":0},{"nr":57,"busy":0},{"nr":58,"busy":0},{"nr":59,"busy":0},{"nr":60,"busy":0},{"nr":61,"busy":0},{"nr":62,"busy":0},{"nr":63,"busy":0},{"nr":64,"busy":0},{"nr":65,"busy":0},{"nr":66,"busy":0},{"nr":67,"busy":0},{"nr":68,"busy":0},{"nr":69,"busy":0},{"nr":70,"busy":0},{"nr":71,"busy":0},{"nr":72,"busy":0},{"nr":73,"busy":0},{"nr":74,"busy":0},{"nr":75,"busy":0},{"nr":76,"busy":0},{"nr":77,"busy":0},{"nr":78,"busy":0},{"nr":79,"busy":0},{"nr":80,"busy":0},{"nr":81,"busy":0},{"nr":82,"busy":0},{"nr":83,"busy":0},{"nr":84,"busy":0},{"nr":85,"busy":0},{"nr":86,"busy":0},{"nr":87,"busy":0},{"nr":88,"busy":0},{"nr":89,"busy":0},{"nr":90,"busy":0},{"nr":91,"busy":0},{"nr":92,"busy":0},{"nr":93,"busy":0},{"nr":94,"busy":0},{"nr":95,"busy":0},{"nr":96,"busy":0},{"nr":97,"busy":0},{"nr":98,"busy":0},{"nr":99,"busy":0},{"nr":100,"busy":0},{"nr":101,"busy":0},{"nr":102,"busy":0},{"nr":103,"busy":0},{"nr":104,"busy":0},{"nr":105,"busy":0},{"nr":106,"busy":0},{"nr":107,"busy":0},{"nr":108,"busy":0},{"nr":109,"busy":0},{"nr":110,"busy":0},{"nr":111,"busy":0},{"nr":112,"busy":0},{"nr":113,"busy":0},{"nr":114,"busy":0},{"nr":115,"busy":0},{"nr":116,"busy":0},{"nr":117,"busy":0},{"nr":118,"busy":0},{"nr":119,"busy":0},{"nr":120,"busy":0},{"nr":121,"busy":0},{"nr":122,"busy":0},{"nr":123,"busy":0},{"nr":124,"busy":0},{"nr":125,"busy":0},{"nr":126,"busy":0},{"nr":127,"busy":0},{"nr":128,"busy":0},{"nr":129,"busy":0},{"nr":130,"busy":0},{"nr":131,"busy":0},{"nr":132,"busy":0},{"nr":133,"busy":0},{"nr":134,"busy":0},{"nr":135,"busy":0},{"nr":136,"busy":0},{"nr":137,"busy":0},{"nr":138,"busy":0},{"nr":139,"busy":0},{"nr":140,"busy":0},{"nr":141,"busy":0},{"nr":142,"busy":0},{"nr":143,"busy":0},{"nr":144,"busy":0},{"nr":145,"busy":0},{"nr":146,"busy":0},{"nr":147,"busy":0},{"nr":148,"busy":0},{"nr":149,"busy":0},{"nr":150,"busy":0},{"nr":151,"busy":0},{"nr":152,"busy":0},{"nr":153,"busy":0},{"nr":154,"busy":0},{"nr":155,"busy":0},{"nr":156,"busy":0},{"nr":157,"busy":0},{"nr":158,"busy":0},{"nr":159,"busy":0},{"nr":160,"busy":0},{"nr":161,"busy":0},{"nr":162,"busy":0},{"nr":163,"busy":0},{"nr":164,"busy":0},{"nr":165,"busy":0},{"nr":166,"busy":0},{"nr":167,"busy":0},{"nr":168,"busy":0},{"nr":169,"busy":0},{"nr":170,"busy":0},{"nr":171,"busy":0},{"nr":172,"busy":0},{"nr":173,"busy":0},{"nr":174,"busy":0},{"nr":175,"busy":0},{"nr":176,"busy":0},{"nr":177,"busy":0},{"nr":178,"busy":0},{"nr":179,"busy":0},{"nr":180,"busy":0},{"nr":181,"busy":0},{"nr":182,"busy":0},{"nr":183,"busy":0},{"nr":184,"busy":0},{"nr":185,"busy":0},{"nr":186,"busy":0},{"nr":187,"busy":0},{"nr":188,"busy":0},{"nr":189,"busy":0},{"nr":190,"busy":0},{"nr":191,"busy":0},{"nr":192,"busy":0},{"nr":193,"busy":0},{"nr":194,"busy":0},{"nr":195,"busy":0},{"nr":196,"busy":0},{"nr":197,"busy":0},{"nr":198,"busy":0},{"nr":199,"busy":0},{"nr":200,"busy":0},{"nr":201,"busy":0},{"nr":202,"busy":0},{"nr":203,"busy":0},{"nr":204,"busy":0},{"nr":205,"busy":0},{"nr":206,"busy":0},{"nr":207,"busy":0},{"nr":208,"busy":0},{"nr":209,"busy":0},{"nr":210,"busy":0},{"nr":211,"busy":0},{"nr":212,"busy":0},{"nr":213,"busy":0},{"nr":214,"busy":0},{"nr":215,"busy":0},{"nr":216,"busy":0},{"nr":217,"busy":0},{"nr":218,"busy":0},{"nr":219,"busy":0},{"nr":220,"busy":0},{"nr":221,"busy":0},{"nr":222,"busy":0},{"nr":223,"busy":0},{"nr":224,"busy":0},{"nr":225,"busy":0},{"nr":226,"busy":0},{"nr":227,"busy":0},{"nr":228,"busy":0},{"nr":229,"busy":0},{"nr":230,"busy":0},{"nr":231,"busy":0},{"nr":232,"busy":0},{"nr":233,"busy":0},{"nr":234,"busy":0},{"nr":235,"busy":0},{"nr":236,"busy":0},{"nr":237,"busy":0},{"nr":238,"busy":0},{"nr":239,"busy":0},{"nr":240,"busy":0},{"nr":241,"busy":0},{"nr":242,"busy":0},{"nr":243,"busy":0},{"nr":244,"busy":0},{"nr":245,"busy":0},{"nr":246,"busy":0},{"nr":247,"busy":0},{"nr":248,"busy":0},{"nr":249,"busy":0},{"nr":250,"busy":0},{"nr":251,"busy":0},{"nr":252,"busy":0},{"nr":253,"busy":0},{"nr":254,"busy":0},{"nr":255,"busy":0},{"nr":256,"busy":0},{"nr":257,"busy":0},{"nr":258,"busy":0},{"nr":259,"busy":0},{"nr":260,"busy":0},{"nr":261,"busy":0},{"nr":262,"busy":0},{"nr":263,"busy":0},{"nr":264,"busy":0},{"nr":265,"busy":0},{"nr":266,"busy":0},{"nr":267,"busy":0},{"nr":268,"busy":0},{"nr":269,"busy":0},{"nr":270,"busy":0},{"nr":271,"busy":0},{"nr":272,"busy":0},{"nr":273,"busy":0},{"nr":274,"busy":0},{"nr":275,"busy":0},{"nr":276,"busy":0},{"nr":277,"busy":0},{"nr":278,"busy":0},{"nr":279,"busy":0},{"nr":280,"busy":0},{"nr":281,"busy":0},{"nr":282,"busy":0},{"nr":283,"busy":0},{"nr":284,"busy":0},{"nr":285,"busy":0},{"nr":286,"busy":0},{"nr":287,"busy":0},{"nr":288,"busy":0},{"nr":289,"busy":0},{"nr":290,"busy":0},{"nr":291,"busy":0},{"nr":292,"busy":0},{"nr":293,"busy":0},{"nr":294,"busy":0},{"nr":295,"busy":0},{"nr":296,"busy":0},{"nr":297,"busy":0},{"nr":298,"busy":0},{"nr":299,"busy":0},{"nr":300,"busy":0}]')
    },
    configDateTimePicker: {
      enableTime: true,
      dateFormat: 'Y-m-d H:i'
    },
    // popup flags
    showDetailsPopUp: false,
    showConfirmPopUp: false,
  }),
  methods: {
    ...mapActions(['fetchEvents']),
    ...mapActions(['createEvent']),
    ...mapActions(['getAllLocations']),
    ...mapActions(['setIsLoading']),

    generateNums() {
      this.newEventObj.nums = []
      for (let x = parseInt(this.minNums); x <= this.maxNums; x++) {
        this.newEventObj.nums.push({nr: x, busy: 0})
      }
    },
    onConfirmPress() {
      this.fetchEvents();
      this.creatBtnDisabled = true
      this.showConfirmPopUp = false
      this.showDetailsPopUp = false
      this.$toast.success('flohmarkt erstellt')
      this.creatBtnDisabled = false;

    },
    onLocationPress(id, title) {
      this.newEventObj.eventlocation = id,
      this.title = title
    },
    onCreatePress() {
      // split time and date
      this.newEventObj.starttime = this.newEventObj.startdate.split(' ')[1] + ":00"
      this.newEventObj.startdate = this.newEventObj.startdate.split(' ')[0]
      this.newEventObj.endtime = this.newEventObj.enddate.split(' ')[1] + ":00"
      this.newEventObj.enddate = this.newEventObj.enddate.split(' ')[0]
      this.newEventObj.nums = JSON.stringify(this.newEventObj.nums);
      //create event request
      this.createEvent(this.newEventObj).then(_ => {
        let isCreated = this.$store.getters.getIsEventCreated
        if (isCreated) {
          this.onConfirmPress()
        } else {
          alert('Something went wrong')
        }
      })
    }
  },
  mounted() {
    this.setIsLoading(true)
    //get all locations of the events
    this.getAllLocations().then(_ => {
      this.eventLocations = this.$store.getters.getAllLocations

    })
    this.fetchEvents().then(_ => {
      // let allEvents = this.$store.getters.getAllEvents
      // this.upcomingEvents = allEvents.filter((event) => {
      //   return new Date(event.startdate) >= new Date()
      // })
      // this.goneEvents = allEvents.filter((event) => {
      //   return new Date(event.startdate) < new Date()
      // })
    }).then(() => {
      setTimeout(() => {
        this.setIsLoading(false)
      }, 1000)
    })
  },
  computed: {

    upcomingEvents() {
      return this.$store.getters.getAllEvents
        .filter((event) => {
          return new Date(event.startdate) >= new Date()
        })
    },
    goneEvents() {
      return this.$store.getters.getAllEvents
        .filter((event) => {
          return new Date(event.startdate) < new Date()
        })
    },
    searchEvents() {
      if (this.activeTab === 0) {
        return this.upcomingEvents.filter((event) => {
          return event.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        });
      } else {
        return this.goneEvents.filter((event) => {
          return event.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        });
      }
    },
  }
}
</script>

<style scoped>
.popup-example {
  height: inherit;
}
.confirm-modal {
    z-index: 99999999;
  }
.flatpickr-calendar.open {
  z-index: 999999;
}
</style>

